import { EMfaMethod, ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TUpdateWorkerMfaMethodRequest } from "./updateWorkerMfaMethodSchema";

export type TUpdateWorkerMfaMethodResponse = {
  email: string;
  mfaMethod: EMfaMethod[];
};

export const updateWorkerMfaMethod = (axios: IAxiosInstance) => {
  return async (data: TUpdateWorkerMfaMethodRequest) => {
    const response = await axios.noRetry.patch<
      ZealApiResponse<TUpdateWorkerMfaMethodResponse>
    >(`/api/mfaMethod`, { ...data });
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error("Failed to update worker MFA method");
  };
};
